// export {}; 

export interface User {
    Us_Id: string;
    Us_In_Id: number;
    Us_Nombre: string;
    Us_Usuario: string;
    Us_Estado: string;    
}

export interface EstadoServicios {
  id: number;
  texto: string;
  color: string;
}
  
export const estadoMisServicios: EstadoServicios[] = [
  { id: 1, texto: 'Abierto', color: '#EDF3F6' }, // Neutro
  { id: 2, texto: 'Finalizado', color: '#FBE6BC' }, // Ambar
  { id: 3, texto: 'Liquidado', color: '#DBE5EE' }, // Azul acero
  { id: 4, texto: 'Cancelado', color: '#E1E6E9' }, // Gris
];

export const estadoServicios: EstadoServicios[] = [
  { id: 1, texto: 'Abierto', color: '#EDF3F6' }, // Neutro
  { id: 2, texto: 'Finalizado', color: '#FBE6BC' }, // Ambar
];